/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { atom } from 'jotai'

import { Country, getCountryByCode } from '@/utils/countries'

/**
 * An atom that stores the currently selected country. Used for billing address
 * and pricing. Initialised from the region's representative country by
 * RegionHydration, but can be overridden by the billing country selector.
 */
const selectedCountryAtom = atom<Country>(getCountryByCode('GB'))
selectedCountryAtom.debugLabel = 'selectedCountryAtom'

export { selectedCountryAtom }
export type { Country }
